import Image from '@/components/UI/Image';
import { intlNumber } from '@/utils';
import { useGlobal } from '@/utils/useGlobal';
import { useMount } from 'ahooks';
import { useRef } from 'react';
import css from './index.module.scss';
export default function TabInfo() {
    const { useState, useLang, useRouter } = useGlobal();
    const { locale } = useRouter();
    const { t } = useLang('delta_max_static');
    const [currentIndex, setCurrentIndex] = useState(0);

    /**
     * @desc 添加语言默认长度
     */
    const mapSize = {
        es: 417,
        it: 228,
        fr: 455,
        jp: 237,
        de: 333,
        cn: 158,
        ru: 618,
        cis: 618,
    };
    type Asmapsize = keyof typeof mapSize;
    const [tabPosition, setTabPosition] = useState({
        tabWidth: mapSize[locale as Asmapsize] || 170,
        offsetLeft: 0,
    });

    type iconInfo = {
        icon: string;
        device: string;
        usageTime: {
            time: number | string;
            unit: string;
            port?: string;
        }[];
    };

    type useTimeList = {
        key: number;
        title: string;
        img: string;
        content: iconInfo[];
    };

    const isAr = locale == 'sa';
    const getFinalUnit = (baseUnit: string, arabUnit: string) => {
        return isAr ? arabUnit : baseUnit;
    };

    const useTimeList: useTimeList[] = [
        {
            key: 0,
            title: t('HB'),
            img: '/media/deltamax/pc/useTime/delta-max01.png',
            content: [
                {
                    icon: '/media/deltamax/pc/useTime/homeBc01.svg',
                    device: 'Light',
                    usageTime: [{ time: 189, unit: getFinalUnit(t('Hrs'), t('Hrs1')) }],
                },
                // {
                //     icon: '/media/deltamax/pc/useTime/homeBc02.svg',
                //     device: 'CPAP',
                //     usageTime: [{ time: 34, unit: getFinalUnit(t('Hrs'), t('Hrs1')) }],
                // },
                {
                    icon: '/media/deltamax/pc/useTime/homeBc03.svg',
                    device: 'Refrigerator',
                    usageTime: [{ time: 14, unit: getFinalUnit(t('Hrs'), t('Hrs1')) }],
                },
                {
                    icon: '/media/deltamax/pc/useTime/homeBc04.svg',
                    device: 'Microwave',
                    usageTime: [
                        {
                            time: intlNumber(locale, 1.5),
                            unit: getFinalUnit(locale === 'fr' ? t('OneHrs') : t('Hrs'), t('Hrs4')),
                        },
                    ],
                },
                {
                    icon: '/media/deltamax/pc/useTime/homeBc05.svg',
                    device: 'Washer',
                    usageTime: [{ time: intlNumber(locale, 3.8), unit: getFinalUnit(t('Hrs'), t('Hrs4')) }],
                },
                {
                    icon: '/media/deltamax/pc/useTime/homeBc06.svg',
                    device: 'Electric Frying Pan',
                    usageTime: [
                        {
                            time: intlNumber(locale, 1.6),
                            unit: getFinalUnit(locale === 'fr' ? t('OneHrs') : t('Hrs'), t('Hrs4')),
                        },
                    ],
                },
                {
                    icon: '/media/deltamax/pc/useTime/homeBc07.svg',
                    device: '50" TV',
                    usageTime: [{ time: 15, unit: getFinalUnit(t('Hrs'), t('Hrs1')) }],
                },
                {
                    icon: '/media/deltamax/pc/useTime/homeBc08.svg',
                    device: 'Hair Dryer',
                    usageTime: [
                        {
                            time: intlNumber(locale, 1.1),
                            unit: getFinalUnit(locale === 'fr' ? t('OneHrs') : t('Hrs'), t('Hrs4')),
                        },
                    ],
                },
                {
                    icon: '/media/deltamax/pc/useTime/homeBc09.svg',
                    device: 'Coffee Maker',
                    usageTime: [
                        {
                            time: intlNumber(locale, 1.9),
                            unit: getFinalUnit(locale === 'fr' ? t('OneHrs') : t('Hrs'), t('Hrs4')),
                        },
                    ],
                },
            ],
        },
        {
            key: 1,
            title: t('OGL'),
            img: '/media/deltamax/pc/useTime/delta-max02.png',
            content: [
                {
                    icon: '/media/deltamax/pc/useTime/offGL01.svg',
                    device: 'Phone',
                    usageTime: [{ time: 175, unit: getFinalUnit(t('Times'), t('Times1')) }],
                },
                {
                    icon: '/media/deltamax/pc/useTime/offGL02.svg',
                    device: 'Laptop',
                    usageTime: [{ time: 32, unit: getFinalUnit(t('Times'), t('Times1')) }],
                },
                {
                    icon: '/media/deltamax/pc/useTime/offGL03.svg',
                    device: 'Camera',
                    usageTime: [{ time: 118, unit: getFinalUnit(t('Times'), t('Times1')) }],
                },
                {
                    icon: '/media/deltamax/pc/useTime/offGL04.svg',
                    device: 'Drone',
                    usageTime: [{ time: 48, unit: getFinalUnit(t('Times'), t('Times1')) }],
                },
                {
                    icon: '/media/deltamax/pc/useTime/offGL05.svg',
                    device: 'Speaker',
                    usageTime: [{ time: 60, unit: getFinalUnit(t('Hrs'), t('Hrs1')) }],
                },
                {
                    icon: '/media/deltamax/pc/useTime/offGL06.svg',
                    device: 'Blender',
                    usageTime: [{ time: intlNumber(locale, 3.8), unit: getFinalUnit(t('Hrs'), t('Hrs4')) }],
                },
                {
                    icon: '/media/deltamax/pc/useTime/offGL07.svg',
                    device: 'Car Fridge',
                    usageTime: [{ time: 33, unit: getFinalUnit(t('Hrs'), t('Hrs1')) }],
                },
                {
                    icon: '/media/deltamax/pc/useTime/offGL08.svg',
                    device: 'Projector',
                    usageTime: [{ time: 24, unit: getFinalUnit(t('Hrs'), t('Hrs1')) }],
                },
                {
                    icon: '/media/deltamax/pc/useTime/offGL09.svg',
                    device: 'PS5',
                    usageTime: [{ time: 9, unit: getFinalUnit(t('Hrs'), t('Hrs3')) }],
                },
            ],
        },
        {
            key: 2,
            title: t('Professional'),
            img: '/media/deltamax/pc/useTime/delta-max03.png',
            content: [
                {
                    icon: '/media/deltamax/pc/useTime/professional01.svg',
                    device: 'Circular Saw',
                    usageTime: [
                        {
                            time: intlNumber(locale, 1.3),
                            unit: getFinalUnit(locale === 'fr' ? t('OneHrs') : t('Hrs'), t('Hrs4')),
                        },
                    ],
                },
                {
                    icon: '/media/deltamax/pc/useTime/professional02.svg',
                    device: 'Air Conditioner',
                    usageTime: [{ time: 1, unit: getFinalUnit(['fr', 'de'].includes(locale) ? t('OneHrs') : t('Hrs'), t('Hrs1')) }],
                },
                {
                    icon: '/media/deltamax/pc/useTime/professional03.svg',
                    device: 'Electric Hammer',
                    usageTime: [
                        {
                            time: intlNumber(locale, 1.5),
                            unit: getFinalUnit(locale === 'fr' ? t('OneHrs') : t('Hrs'), t('Hrs4')),
                        },
                    ],
                },
                {
                    icon: '/media/deltamax/pc/useTime/professional04.svg',
                    device: 'Electric Drill',
                    usageTime: [
                        {
                            time: intlNumber(locale, 1.8),
                            unit: getFinalUnit(locale === 'fr' ? t('OneHrs') : t('Hrs'), t('Hrs4')),
                        },
                    ],
                },
                {
                    icon: '/media/deltamax/pc/useTime/professional05.svg',
                    device: 'Cutting Machine',
                    usageTime: [
                        {
                            time: intlNumber(locale, 1.7),
                            unit: getFinalUnit(locale === 'fr' ? t('OneHrs') : t('Hrs'), t('Hrs4')),
                        },
                    ],
                },
                {
                    icon: '/media/deltamax/pc/useTime/professional06.svg',
                    device: 'Electric Oven',
                    usageTime: [
                        {
                            time: intlNumber(locale, 1.1),
                            unit: getFinalUnit(locale === 'fr' ? t('OneHrs') : t('Hrs'), t('Hrs4')),
                        },
                    ],
                },
                {
                    icon: '/media/deltamax/pc/useTime/professional07.svg',
                    device: 'Electric Grill',
                    usageTime: [
                        {
                            time: intlNumber(locale, 1.7),
                            unit: getFinalUnit(locale === 'fr' ? t('OneHrs') : t('Hrs'), t('Hrs4')),
                        },
                    ],
                },
                {
                    icon: '/media/deltamax/pc/useTime/professional08.svg',
                    device: 'Air Fryer',
                    usageTime: [
                        {
                            time: intlNumber(locale, 1.2),
                            unit: getFinalUnit(locale === 'fr' ? t('OneHrs') : t('Hrs'), t('Hrs4')),
                        },
                    ],
                },
            ],
        },
    ];

    const setTab = (key: number, target: any) => {
        const { clientWidth, offsetLeft } = target;
        setTabPosition({ tabWidth: clientWidth, offsetLeft });
        setCurrentIndex(key);
    };

    const handleChangeTab = (key: number, event: any) => {
        const dom = event.target;
        setTab(key, dom);
    };

    const boxRef = useRef<HTMLDivElement>(null);

    useMount(() => {
        try {
            if (boxRef?.current) {
                setTab(0, boxRef.current.childNodes[0]);
            }
        } catch (e) {}
    });

    return (
        <div className={css.use_time}>
            <div className="container">
                <div className="head font-family-bold">
                    {t.rich('AYCP', {
                        line1: (child: string) => <div className="l1">{child}</div>,
                        line2: (child: string) => <div className="l2">{child}</div>,
                    })}
                </div>
                <div className="tab">
                    <ul ref={boxRef}>
                        {useTimeList.map((item) => (
                            <li
                                key={item.key}
                                className={`menuItem font-family-semibold ${currentIndex === item.key ? 'active' : ''}`}
                                onClick={(e) => handleChangeTab(item.key, e)}
                            >
                                {item.title}
                            </li>
                        ))}
                    </ul>
                    <div
                        className="line"
                        style={{
                            left: `${tabPosition.offsetLeft}px`,
                            width: `${tabPosition.tabWidth}px`,
                        }}
                    />
                </div>
                <ul className="content">
                    {useTimeList
                        .find((item) => item.key === currentIndex)
                        ?.content.map((item, index) => (
                            <li className="item" key={index}>
                                <Image src={item.icon} width={96} height={96} alt={t(item.device)} />
                                <p className="device font-family-regular">{t(item.device)}</p>
                                <ul className="usageTime ">
                                    {item.usageTime?.map((usageTimeItem, index) => (
                                        <li className="usageTimeItem font-family-bold" key={index}>
                                            <p>
                                                <strong className="time">{usageTimeItem.time}</strong>
                                                <span className="unit">&nbsp; &nbsp;{usageTimeItem.unit}</span>
                                            </p>
                                            <p className="port">{usageTimeItem.port}</p>
                                        </li>
                                    ))}
                                </ul>
                            </li>
                        ))}
                </ul>
                {locale === 'cn' && <p className="memo">{t('useTime_memo')}</p>}
            </div>
        </div>
    );
}
